module.exports = __webpack_public_path__ + "img/fail.f23feef5.svg";